<script setup>
// ConversationSidebar.vue
import { computed, inject } from 'vue';
import ContactPanel from 'dashboard/routes/dashboard/conversation/ContactPanel.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useWindowSize } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import wootConstants from 'dashboard/constants/globals';
import { SIDEPANEL_INJECTION_KEY } from 'dashboard/components-next/Conversation/sidepanels';

defineProps({
  currentChat: {
    required: true,
    type: Object,
  },
});

const { uiSettings, updateUISettings } = useUISettings();
const { width: windowWidth } = useWindowSize();

// Quem hospeda a conversa num contexto transitório (a ConversationSheet do
// quadro) injeta o painel ativo em vez de gravar na preferência do perfil —
// ver `sidepanels.js`. Sem honrar a injeção, o switch da sheet marcava
// "contato" no estado local e este componente seguia lendo `uiSettings`
// (false), montando o painel com `md:hidden`: o botão acendia e nada abria.
const sidepanel = inject(SIDEPANEL_INJECTION_KEY, null);

const activeTab = computed(() => {
  const isContactSidebarOpen = sidepanel
    ? sidepanel.value === 'contact'
    : uiSettings.value.is_contact_sidebar_open;

  if (isContactSidebarOpen) {
    return 0;
  }
  return null;
});

const isSmallScreen = computed(
  () => windowWidth.value < wootConstants.SMALL_SCREEN_BREAKPOINT
);

const closeContactPanel = () => {
  if (isSmallScreen.value && uiSettings.value?.is_contact_sidebar_open) {
    updateUISettings({
      is_contact_sidebar_open: false,
      is_copilot_panel_open: false,
    });
  }
};
</script>

<template>
  <div
    v-on-click-outside="() => closeContactPanel()"
    class="bg-n-background h-full overflow-hidden flex flex-col fixed top-0 z-40 w-full max-w-sm transition-transform duration-300 ease-in-out ltr:right-0 rtl:left-0 md:static md:w-[260px] md:min-w-[260px] ltr:border-l rtl:border-r border-n-weak 2xl:min-w-[300px] 2xl:w-[300px] shadow-lg md:shadow-none"
    :class="[
      {
        'md:flex': activeTab === 0,
        'md:hidden': activeTab !== 0,
      },
    ]"
  >
    <div class="flex flex-1 overflow-auto">
      <ContactPanel
        v-show="activeTab === 0"
        :conversation-id="currentChat.id"
        :inbox-id="currentChat.inbox_id"
      />
    </div>
  </div>
</template>
